export const CONTACT_EMAIL = "thewebessence@gmail.com";
export const INSTAGRAM_HANDLE = "@thewebessence";
export const INSTAGRAM_URL = "https://instagram.com/thewebessence";

export const Brand = ({ className = "", light = "font-light", heavy = "font-black" }) => (
  <span className={`font-head tracking-tight ${className}`}>
    <span className={light}>Web</span>
    <span className={heavy}>Essence</span>
  </span>
);
